import { useNavigate } from 'react-router-dom';
import SITE from '../data/site';
import { FaqItem } from '../components/UI';

export default function Contact() {
  const nav = useNavigate();
  const { clinic, faq } = SITE;

  return (
    <div style={{ paddingTop: 72 }}>
      <div className="page-band">
        <div className="container">
          <div className="breadcrumb">
            <a onClick={() => nav('/')}>الرئيسية</a><span>/</span>تواصل معنا
          </div>
          <h1>تواصل معنا</h1>
        </div>
      </div>

      <section className="sec sec-warm">
        <div className="container">
          <div className="sec-head">
            <span className="sec-eyebrow">تواصل معنا</span>
            <h2>كيف تصل إلينا؟</h2>
            <div className="gold-line" />
          </div>

          <div className="contact-grid">
            <a href={`tel:${clinic.phone}`} className="ctc-card">
              <div className="ctc-icon">📞</div>
              <h3>رقم الاتصال والواتس اب</h3>
              <div className="ctc-val">{clinic.phone}</div>
            </a>
            <a href={`mailto:${clinic.email}`} className="ctc-card">
              <div className="ctc-icon">✉️</div>
              <h3>راسلنا</h3>
              <p>{clinic.email}</p>
            </a>
            <a href={clinic.mapUrl} target="_blank" rel="noreferrer" className="ctc-card">
              <div className="ctc-icon">📍</div>
              <h3>العنوان</h3>
              <p>{clinic.address}</p>
              {/* <p>{clinic.address2}</p> */}
            </a>
          </div>

          <div className="wa-block">
            <div className="wa-ico">💬</div>
            <h3>تواصل معنا على واتساب</h3>
            <p>احجز موعدك بسهولة عبر واتساب أو استفسر عن أي خدمة من خدماتنا</p>
            <a
              className="btn btn-wa"
              href={clinic.whatsapp}
              target="_blank"
              rel="noreferrer"
              style={{ display: 'inline-flex', fontSize: '1rem', padding: '13px 36px' }}
            >
              💬 ابدأ المحادثة على واتساب
            </a>
          </div>

          <div style={{ marginTop: 68  }}>
            <div className="sec-head" >
              <span className="sec-eyebrow">أسئلة وأجوبة</span>
              <h2>الأسئلة الشائعة</h2>
              <div className="gold-line" />
            </div>
            <div className="faq-wrap" style={{backgroundColor : 'var(--black)'}} >
              {faq.map((f, i) => <FaqItem key={i} q={f.q} a={f.a} />)}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
